import {Injectable} from '@angular/core';
import {Store} from '../classes/store';
import {Project} from '../../../resources/project/project.interface';


@Injectable({
  providedIn: 'root'
})
export class ProjectStore extends Store<Project> {

  /** Constructor. */
  constructor() {
    super();
  }

  /**
   * Return first project.
   *
   * @todo Currently always returns the first (and only) project, but once there is,
   *  multi project support, find a way to return the *current* project.
   *
   * @returns Project.
   */
  get(): Project {
    return this.state[0];
  }

  /**
   * Sets the project and passes all its data to the other stores.
   *
   * @param project Project.
   */
  setState(project: Project[]) {
    super.setState(project);
  }


}
